<template>
  <div class="newwarp boxsizing miniwarp">
    <div class="auto">
      <page-title title="京东活动数据">
        <div>
          <el-select v-model="group" placeholder="请选择" size="small" class="m-lr-5">
            <el-option
              v-for="item in groupOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
          <el-select v-model="link" placeholder="请选择" size="small">
            <el-option
              v-for="item in linkOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </div>
      </page-title>
    </div>

    <!-- <el-row class="m-t-15" v-loading="summaryLoading">
      <el-col :span="12">
        <div class="padding-15">
          <dufault-column height="auto" title="店铺">
            <div slot="content">
              <el-row>
                <el-col :span="24">
                  <div class="flex-box auto">
                    <div class="useraddbox auto">
                      PV
                      <p>{{util.numberFormat(summary.pv || 0)}}</p>
                    </div>
                    <div class="useraddbox auto">
                      UV
                      <p>{{util.numberFormat(summary.uv || 0)}}</p>
                    </div>
                    <div class="useraddbox auto">
                      店铺首页pv
                      <p>{{util.numberFormat(summary.shop_pv_num || 0)}}</p>
                    </div>
                    <div class="useraddbox auto">
                      店铺首页uv
                      <p>{{util.numberFormat(summary.shop_uv_num || 0)}}</p>
                    </div>
                  </div>
                  <div class="flex-box auto">
                    <div class="useraddbox auto">
                      店铺收藏人数
                      <p>{{util.numberFormat(summary.follow_shop_pins || 0)}}</p>
                    </div>
                    <div class="useraddbox auto">
                      加购人数
                      <p>{{util.numberFormat(summary.cart_users || 0)}}</p>
                    </div>
                    <div class="useraddbox auto">
                      店铺下单人数
                      <p>{{util.numberFormat(summary.shop_ord_pins || 0)}}</p>
                    </div>
                    <div class="useraddbox auto">
                      订单数
                      <p>{{util.numberFormat(summary.shop_ord_num || 0)}}</p>
                    </div>
                  </div>
                  <div class="flex-box nopadbotbox auto">
                    <div class="useraddbox auto">
                      下单商品数
                      <p>{{util.numberFormat(summary.shop_ord_qtty || 0)}}</p>
                    </div>
                    <div class="useraddbox auto">
                      支付人数
                      <p>{{util.numberFormat(summary.shop_pay_pins || 0)}}</p>
                    </div>
                    <div class="useraddbox auto">
                      支付订单数
                      <p>{{util.numberFormat(summary.shop_pay_num || 0)}}</p>
                    </div>
                    <div class="useraddbox auto">
                      支付商品数
                      <p>{{util.numberFormat(summary.shop_pay_qtty || 0)}}</p>
                    </div>
                  </div>
                </el-col>
              </el-row>
            </div>
          </dufault-column>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="padding-15">
          <dufault-column height="auto" title="产品">
            <div slot="content">
              <el-row>
                <el-col :span="24">
                  <div class="flex-box auto">
                    <div class="useraddbox auto">
                      商详pv
                      <p>{{util.numberFormat(summary.sku_pv_num || 0)}}</p>
                    </div>
                    <div class="useraddbox auto">
                      商详uv
                      <p>{{util.numberFormat(summary.sku_uv_num || 0)}}</p>
                    </div>
                    <div class="useraddbox auto">
                      商品收藏人数
                      <p>{{util.numberFormat(summary.follow_sku_pins || 0)}}</p>
                    </div>
                    <div class="useraddbox auto">
                      下单人数
                      <p>{{util.numberFormat(summary.sku_ord_pins || 0)}}</p>
                    </div>
                  </div>
                  <div class="flex-box auto">
                    <div class="useraddbox auto">
                      订单数
                      <p>{{util.numberFormat(summary.sku_ord_num || 0)}}</p>
                    </div>
                    <div class="useraddbox auto">
                      商品数
                      <p>{{util.numberFormat(summary.sku_ord_qtty || 0)}}</p>
                    </div>
                    <div class="useraddbox auto">
                      支付人数
                      <p>{{util.numberFormat(summary.sku_pay_pins || 0)}}</p>
                    </div>
                    <div class="useraddbox auto">
                      支付订单数
                      <p>{{util.numberFormat(summary.sku_pay_num || 0)}}</p>
                    </div>
                  </div>
                  <div class="flex-box nopadbotbox auto">
                    <div class="useraddbox auto">
                      支付商品数
                      <p>{{util.numberFormat(summary.sku_pay_qtty || 0)}}</p>
                    </div>
                    <div class="useraddbox auto">
                      订单金额
                      <p>{{util.numberFormat(summary.sku_ord_amount || 0)}}</p>
                    </div>
                    <div class="useraddbox auto">
                    </div>
                    <div class="useraddbox auto">
                    </div>
                  </div>
                </el-col>
              </el-row>
            </div>
          </dufault-column>
        </div>
      </el-col>
    </el-row> -->
    <el-row class="m-t-15">
      <el-col :span="24">
        <div class="padding-15">
          <dufault-column height="auto" :notitle="true" v-loading="summaryLoading">
            <div slot="content">
              <el-row align="middle">
                <el-col :span="6" align="center" class="usercountbox">
                  <p class="font20">
                    店铺
                  </p>
                  <span class="m-lr-5">
                    UV {{util.numberFormat(summary['uv'] || 0)}}
                  </span>
                  |
                  <span class="m-lr-5">
                    PV {{util.numberFormat(summary.pv || 0)}}
                  </span>
                </el-col>
                <el-col :span="18" style="border-left:1px solid #ccc;">
                  <div class="auto flex-box">
                    <div class="benchbox benchbox1 nobor auto">
                      店铺首页pv
                      <p>{{util.numberFormat(summary.shop_pv_num || 0)}}</p>
                    </div>
                    <div class="benchbox benchbox2 nobor auto">
                      店铺首页uv
                      <p>{{util.numberFormat(summary.shop_uv_num || 0)}}</p>
                    </div>
                    <div class="benchbox benchbox3 nobor auto">
                      店铺收藏人数
                      <p>{{util.numberFormat(summary.follow_shop_pins || 0)}}</p>
                    </div>
                    <div class="benchbox benchbox4 nobor auto">
                      加购人数
                      <p>{{util.numberFormat(summary.cart_users || 0)}}</p>
                    </div>
                    <div class="benchbox benchbox5 nobor auto">
                      店铺下单人数
                      <p>{{util.numberFormat(summary.shop_ord_pins || 0)}}</p>
                    </div>
                  </div>
                  <div class="auto flex-box">
                    <div class="benchbox benchbox5 nobor auto">
                      订单数
                      <p>{{util.numberFormat(summary.shop_ord_num || 0)}}</p>
                    </div>
                    <div class="benchbox benchbox4 nobor auto">
                      下单商品数
                      <p>{{util.numberFormat(summary.shop_ord_qtty || 0)}}</p>
                    </div>
                    <div class="benchbox benchbox3 nobor auto">
                      支付人数
                      <p>{{util.numberFormat(summary.shop_pay_pins || 0)}}</p>
                    </div>
                    <div class="benchbox benchbox2 nobor auto">
                      支付订单数
                      <p>{{util.numberFormat(summary.shop_pay_num || 0)}}</p>
                    </div>
                    <div class="benchbox benchbox1 nobor auto">
                      支付商品数
                      <p>{{util.numberFormat(summary.shop_pay_qtty || 0)}}</p>
                    </div>
                  </div>
                </el-col>
              </el-row>
            </div>
          </dufault-column>
        </div>
      </el-col>
    </el-row>
    <el-row class="m-t-15">
      <el-col :span="24">
        <div class="padding-15">
          <dufault-column height="auto" :notitle="true" v-loading="summaryLoading">
            <div slot="content">
              <el-row align="middle">
                <el-col :span="6" align="center" class="usercountbox usercountbox2">
                  <p class="font20">
                    产品
                  </p>
                </el-col>
                <el-col :span="18" style="border-left:1px solid #ccc;">
                  <div class="auto flex-box">
                    <div class="benchbox benchbox1 nobor auto">
                      商详pv
                      <p>{{util.numberFormat(summary.sku_pv_num || 0)}}</p>
                    </div>
                    <div class="benchbox benchbox2 nobor auto">
                      商详uv
                      <p>{{util.numberFormat(summary.sku_uv_num || 0)}}</p>
                    </div>
                    <div class="benchbox benchbox3 nobor auto">
                      商品收藏人数
                      <p>{{util.numberFormat(summary.follow_sku_pins || 0)}}</p>
                    </div>
                    <div class="benchbox benchbox4 nobor auto">
                      下单人数
                      <p>{{util.numberFormat(summary.sku_ord_pins || 0)}}</p>
                    </div>
                    <div class="benchbox benchbox5 nobor auto">
                      订单数
                      <p>{{util.numberFormat(summary.sku_ord_num || 0)}}</p>
                    </div>
                  </div>
                  <div class="auto flex-box">
                    <div class="benchbox benchbox5 nobor auto">
                      商品数
                      <p>{{util.numberFormat(summary.sku_ord_qtty || 0)}}</p>
                    </div>
                    <div class="benchbox benchbox4 nobor auto">
                      支付人数
                      <p>{{util.numberFormat(summary.sku_pay_pins || 0)}}</p>
                    </div>
                    <div class="benchbox benchbox3 nobor auto">
                      支付订单数
                      <p>{{util.numberFormat(summary.sku_pay_num || 0)}}</p>
                    </div>
                    <div class="benchbox benchbox2 nobor auto">
                      支付商品数
                      <p>{{util.numberFormat(summary.sku_pay_qtty || 0)}}</p>
                    </div>
                    <div class="benchbox benchbox1 nobor auto">
                      订单金额
                      <p>{{util.numberFormat(summary.sku_ord_amount || 0)}}</p>
                    </div>
                  </div>
                </el-col>
              </el-row>
            </div>
          </dufault-column>
        </div>
      </el-col>
    </el-row>

    <el-row class="m-t-15">
      <el-col :span="24" align="right">
        <dates-picker v-model="date" size="small"></dates-picker>
      </el-col>
    </el-row>
    <el-row class="m-t-15">
      <el-col :span="24">
        <div class="padding-15">
          <dufault-column height="auto" title="店铺" v-loading="detailLoading">
            <div slot="content">
              <el-row>
                <el-col :span="12">
                  <div class="flex-box auto">
                    <div class="useraddbox auto">
                      PV
                      <p>{{util.numberFormat(detailTotal.pv || 0)}}</p>
                    </div>
                    <div class="useraddbox auto">
                      UV
                      <p>{{util.numberFormat(detailTotal.uv || 0)}}</p>
                    </div>
                    <div class="useraddbox auto">
                      首页pv
                      <p>{{util.numberFormat(detailTotal.shop_pv_num || 0)}}</p>
                    </div>
                    <div class="useraddbox auto">
                      首页uv
                      <p>{{util.numberFormat(detailTotal.shop_uv_num || 0)}}</p>
                    </div>
                  </div>
                  <div class="flex-box auto">
                    <div class="useraddbox auto">
                      收藏人数
                      <p>{{util.numberFormat(detailTotal.follow_shop_pins || 0)}}</p>
                    </div>
                    <div class="useraddbox auto">
                      加购人数
                      <p>{{util.numberFormat(detailTotal.cart_users || 0)}}</p>
                    </div>
                    <div class="useraddbox auto">
                      下单人数
                      <p>{{util.numberFormat(detailTotal.shop_ord_pins || 0)}}</p>
                    </div>
                    <div class="useraddbox auto">
                      订单数
                      <p>{{util.numberFormat(detailTotal.shop_ord_num || 0)}}</p>
                    </div>
                  </div>
                  <div class="flex-box nopadbotbox auto">
                    <div class="useraddbox auto">
                      下单商品数
                      <p>{{util.numberFormat(detailTotal.shop_ord_qtty || 0)}}</p>
                    </div>
                    <div class="useraddbox auto">
                      支付人数
                      <p>{{util.numberFormat(detailTotal.shop_pay_pins || 0)}}</p>
                    </div>
                    <div class="useraddbox auto">
                      支付订单数
                      <p>{{util.numberFormat(detailTotal.shop_pay_num || 0)}}</p>
                    </div>
                    <div class="useraddbox auto">
                      支付商品数
                      <p>{{util.numberFormat(detailTotal.shop_pay_qtty || 0)}}</p>
                    </div>
                  </div>
                </el-col>
                <el-col :span="12">
                  <echarts :data="chartData1" title="" height="270" :nohader="true"></echarts>
                </el-col>
              </el-row>
            </div>
          </dufault-column>
        </div>
      </el-col>
    </el-row>
    <el-row class="m-t-15">
      <el-col :span="24">
        <div class="padding-15">
          <dufault-column height="auto" title="产品" v-loading="detailLoading">
            <div slot="content">
              <el-row>
                <el-col :span="12">
                  <div class="flex-box auto">
                    <div class="useraddbox auto">
                      商详pv
                      <p>{{util.numberFormat(detailTotal.sku_pv_num || 0)}}</p>
                    </div>
                    <div class="useraddbox auto">
                      商详uv
                      <p>{{util.numberFormat(detailTotal.sku_uv_num || 0)}}</p>
                    </div>
                    <div class="useraddbox auto">
                      商品收藏人数
                      <p>{{util.numberFormat(detailTotal.follow_sku_pins || 0)}}</p>
                    </div>
                    <div class="useraddbox auto">
                      下单人数
                      <p>{{util.numberFormat(detailTotal.sku_ord_pins || 0)}}</p>
                    </div>
                  </div>
                  <div class="flex-box auto">
                    <div class="useraddbox auto">
                      订单数
                      <p>{{util.numberFormat(detailTotal.sku_ord_num || 0)}}</p>
                    </div>
                    <div class="useraddbox auto">
                      商品数
                      <p>{{util.numberFormat(detailTotal.sku_ord_qtty || 0)}}</p>
                    </div>
                    <div class="useraddbox auto">
                      支付人数
                      <p>{{util.numberFormat(detailTotal.sku_pay_pins || 0)}}</p>
                    </div>
                    <div class="useraddbox auto">
                      支付订单数
                      <p>{{util.numberFormat(detailTotal.sku_pay_num || 0)}}</p>
                    </div>
                  </div>
                  <div class="flex-box nopadbotbox auto">
                    <div class="useraddbox auto">
                      支付商品数
                      <p>{{util.numberFormat(detailTotal.sku_pay_qtty || 0)}}</p>
                    </div>
                    <div class="useraddbox auto">
                      订单金额
                      <p>{{util.numberFormat(detailTotal.sku_ord_amount || 0)}}</p>
                    </div>
                    <div class="useraddbox auto">
                    </div>
                    <div class="useraddbox auto">
                    </div>
                  </div>
                </el-col>
                <el-col :span="12">
                  <echarts :data="chartData2" title="" height="270" :nohader="true"></echarts>
                </el-col>
              </el-row>
            </div>
          </dufault-column>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { Data } from '@/model'
import { Data as DataController } from '@/controller'
export default {
  data () {
    return {
      loading: true,
      group: '',
      groupOptions: [],
      link: '',
      linkOptions: [],
      summary: {},
      summaryLoading: false,
      date: this.util.getDataPickerDefault(),
      detailLoading: false,
      detailTotal: {},
      chartData1: '',
      chartData2: '',
      changeGroupStatus: false
    }
  },
  watch: {
    'group': function (val) {
      this.linkOptions = []
      this.link = ''
      this.getUtmList()
      this.getSummaryData()
      this.getDetailData()
      this.changeGroupStatus = true
      setTimeout(() => {
        this.changeGroupStatus = false
      }, 500)
    },
    'link': function (val) {
      if (!this.changeGroupStatus) {
        this.getSummaryData()
        this.getDetailData()
      }
    },
    'date': function (val) {
      this.getDetailData()
    }
  },
  methods: {
    async getUtmGroupList () {
      let res = await Data.Utm.getUtmGroupList()
      if (!res['err_code']) {
        this.groupOptions = res['data']
        this.group = res['data'][0]['id']
      }
    },
    async getUtmList () {
      let res = await Data.Utm.getUtmList({
        group_id: this.group
      })
      if (!res['err_code']) {
        let options = [{
          id: '',
          name: '全部'
        }]
        res['data'].map(item => {
          options.push(item)
        })
        this.linkOptions = options
      }
    },
    async getSummaryData () {
      this.summaryLoading = true
      let res = await Data.Utm.getSummaryData({
        group_id: this.group,
        link_id: this.link
      })
      this.summaryLoading = false
      if (!res['err_code']) {
        this.summary = res['data']
      }
    },
    async getDetailData () {
      this.detailLoading = true
      let res = await Data.Utm.getDetailData({
        // group_id: '7c9f64711ace47adaf38f0e799ee640e',
        // link_id: '2e296247b48c181eddf2063340498ded',
        group_id: this.group,
        link_id: this.link,
        begin_time: this.date[0],
        end_time: this.date[1]
      })
      this.detailLoading = false
      if (!res['err_code']) {
        this.detailTotal = JSON.stringify(res['data']['total']) === '[]' ? {} : res['data']['total']
        let store = {
          'pv': {
            name: 'PV',
            list: []
          },
          'uv': {
            name: 'UV',
            list: []
          },
          'shop_pv_num': {
            name: '店铺首页pv',
            list: []
          },
          'shop_uv_num': {
            name: '店铺首页uv',
            list: []
          },
          'follow_shop_pins': {
            name: '店铺收藏人数',
            list: []
          },
          'cart_users': {
            name: '加购人数',
            list: []
          },
          'shop_ord_pins': {
            name: '店铺下单人数',
            list: []
          },
          'shop_ord_num': {
            name: '订单数',
            list: []
          },
          'shop_ord_qtty': {
            name: '下单商品数',
            list: []
          },
          'shop_pay_pins': {
            name: '支付人数',
            list: []
          },
          'shop_pay_num': {
            name: '支付订单数',
            list: []
          },
          'shop_pay_qtty': {
            name: '支付商品数',
            list: []
          }
        }
        let product = {
          'sku_pv_num': {
            name: '商详pv',
            list: []
          },
          'sku_uv_num': {
            name: '商详uv',
            list: []
          },
          'follow_sku_pins': {
            name: '商品收藏人数',
            list: []
          },
          'sku_ord_pins': {
            name: '下单人数',
            list: []
          },
          'sku_ord_num': {
            name: '订单数',
            list: []
          },
          'sku_ord_qtty': {
            name: '商品数',
            list: []
          },
          'sku_pay_pins': {
            name: '支付人数',
            list: []
          },
          'sku_pay_num': {
            name: '支付订单数',
            list: []
          },
          'sku_pay_qtty': {
            name: '支付商品数',
            list: []
          },
          'sku_ord_amount': {
            name: '订单金额',
            list: []
          }
        }
        if (res['data']['list'].length) {
          res['data'].list.map(item => {
            for (let key in store) {
              store[key]['list'].push({
                date: item['pday'],
                value: item[key]
              })
            }
            for (let key in product) {
              product[key]['list'].push({
                date: item['pday'],
                value: item[key]
              })
            }
          })
          this.chartData1 = DataController.Index.Line(store)
          this.chartData2 = DataController.Index.Line(product)
        } else {
          this.chartData1 = DataController.Index.Line('')
          this.chartData2 = DataController.Index.Line('')
        }
        // console.log(product)
      }
    }
  },
  created () {
    this.getUtmGroupList()
  },
  mounted () {
  }
}
</script>

<style scoped>

.benchbox {
  flex: 1;
  margin: 0 30px 30px;
  padding: 20px 0;
  border-bottom: 2px solid #ef8e2f;
  text-align: center;
}
.benchbox2 {
  border-color: #6cb12c;
}
.benchbox3 {
  border-color: #39a6fc;
}
.benchbox4 {
  border-color: #58e1c2;
}
.benchbox5 {
  border-color: #b961fc;
}
.benchbox p {
  font-size: 30px;
  font-weight: 300;
  margin-top: 10px;
}

.useraddbox {
  flex: 1;
}
.useraddbox p {
  font-size: 30px;
  font-weight: 300;
  padding: 20px 0 30px;
}
.nopadbotbox .useraddbox p {
  padding-bottom: 0;
}

.usercountbox {
  padding-right: 30px;
}
.usercountbox p {
  margin: 95px 0 50px;
}
.usercountbox2 p {
  margin: 125px 0 50px;
}
.usercountbox span {
  font-weight: 300;
}
.nobor {
  /* border: none; */
  /* margin-bottom: 0px; */
}
</style>
